/**
 * Converts bytes to megabytes
 *
 * @category File
 * @since v1.0.0
 * @param {number} fileSize - The size of the file in bytes
 * @returns {number}
 * @example
 * convertFileSizeToMb(15000000);
 * // => 14.30511474609375
 * @docgen_example
 * convertFileSizeToMb(15000000);
 */
export var convertToMb = function (fileSize) {
    var kbs = fileSize / 1024;
    var mbs = kbs / 1024;
    return mbs;
};
